// store/archiveShow/index.ts
import { createSlice, createAction } from "@reduxjs/toolkit";
import { Archive } from "../../@types/archive";
import findArchive from "./actions/findArchive";

interface ArchiveShowState {
  archive: Partial<Archive>;
  findStatus: "idle" | "pending" | "fulfilled" | "rejected";
  // Si quieres más UI flags, agrégalos aquí (modales, etc.)
}

const initialState: ArchiveShowState = {
  archive: {},
  findStatus: "idle",
};

export const resetArchive = createAction("archiveShow/reset");

const archiveShowSlice = createSlice({
  name: "archiveShow",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetArchive, (state) => {
        state.archive = {};
        state.findStatus = "idle";
      })
      .addCase(findArchive.pending, (state) => {
        state.findStatus = "pending";
        state.archive = {};
      })
      .addCase(findArchive.fulfilled, (state, { payload }) => {
        state.archive = { ...payload };
        state.findStatus = "fulfilled";
      })
      .addCase(findArchive.rejected, (state) => {
        state.findStatus = "rejected";
      });
  },
});

export const archiveShow = archiveShowSlice.reducer;
